<template>
  <div>
    <el-form ref="formRef" :model="privilegeForm" label-width="100px">
      <el-form-item label="会员类型：">
        {{privilegeForm.type == 1?'VIP':privilegeForm.type == 2?'SVIP':''}}
      </el-form-item>
      <el-form-item label="特权图标：">
        <img :src="src" alt="" v-if="src" @click="headImgUpdate" class="cursor" style="width: 80px;height: 80px;margin: 0">
        <div class="add" @click="headImgUpdate" v-else>
          <span>+</span>
        </div>
        <input type="file" accept=".jp2,.jpe,.jpeg,.jpg,.png"  @change="headImgChanged" ref="headImg" multiple="multiple" style="display:none;">
      </el-form-item>
      <el-form-item label="特权名称：">
        <el-input v-model="privilegeForm.title" placeholder="请输入特权名称" style="width:24em;"/>
      </el-form-item>
      <el-form-item label="弹窗文案：">
        <el-input v-model="privilegeForm.description" type="textarea" :autosize="{ minRows: 4, maxRows: 10 }" placeholder="请输入弹窗文案" style="width:24em;"/>
      </el-form-item>
      <el-form-item label="排序：">
        <el-input v-model="privilegeForm.orderNum" placeholder="排序，越大越靠前" style="width:24em;"/>
      </el-form-item>

    </el-form>
    <div class="dialog-footer">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="summit" v-loading="loading">确定</el-button>
    </div>
  </div>

</template>

<script>
import { imgPostFormData } from "@/api/api"
import { updateVipPrivilege } from "@/api/url";

export default {
  name: "GiftManageDialog",
  props: {
    value: Object
  },
  data() {
    return {
      privilegeForm: this.value.privilegeForm,
      idx: this.value.ids,
      loading: false,

      files: null,
      src: this.value.ids > -1?this.value.privilegeForm.img:'',
    }
  },
  methods: {
    cancel() {
      this.$emit("close");
    },

    //更改或添加
    headImgUpdate() {
      this.$refs.headImg.click();
    },

    //选取图片
    headImgChanged(e) {
      if(e.target.files[0]) {
        this.files = e.target.files[0];
        var windowURL = window.URL || window.webkitURL;
        this.src = windowURL.createObjectURL(this.files);
      }
    },

    summit() {
      if(!this.privilegeForm.title) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '请先输入特权名称',
          type: 'warning'
        });
        return false
      }
      if(!this.privilegeForm.description) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '请先输入弹窗文案',
          type: 'warning'
        });
        return false
      }
      if(!this.privilegeForm.orderNum) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '排序不能为空',
          type: 'warning'
        });
        return false
      }
      if(!this.src) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '请先上传特权图标',
          type: 'warning'
        });
        return false
      }
      this.loading = true
      let param = new FormData();
      if (this.idx > -1) {
        param.append('id', this.privilegeForm.id);
      } else {
        param.append('id', '0');
      }
      param.append('title', this.privilegeForm.title);
      param.append('orderNum', this.privilegeForm.orderNum);
      param.append('description', this.privilegeForm.description);
      param.append('file', this.files);
      imgPostFormData(updateVipPrivilege, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          this.$emit('confirm')
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
        this.loading = false
      }).catch(()=>{
        this.loading = false
      })
    }
  },
  mounted() {
  }
}
</script>

<style scoped>
.add {
  width: 80px;
  height: 80px;
  text-align: center;
  line-height: 80px;
  border: 1px dashed #ececec;
  font-size: 30px;
  cursor: pointer;
  float: left;
}
</style>
